import { memo, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { Global } from '@emotion/react';

import { signalLogout } from './actions/tokens';
import AccountButton from './components/AccountButton';
import LanguageProvider from './components/LanguageProvider';
import createApolloClient from './helpers/createApolloClient';
import { getLanguage } from './helpers/localization';
import createSimulateExpiredToken from './helpers/simulateExpiredToken';
import store from './store';
import styles from './styles';

declare global {
  interface Window {
    simulateExpiredToken: () => void;
  }
}

/*
  To be used by React apps.
*/
const apolloClient = createApolloClient({
  accessToken: () => {
    const state = store.getState();
    return state.tokens.access && state.tokens.access.token;
  },
  signalLogout: () => {
    store.dispatch(signalLogout());
  },
});

const AppWrapper = ({ children }: { children: ReactNode }) => (
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <Global styles={styles} />
      <LanguageProvider locale={getLanguage()}>{children}</LanguageProvider>
    </ApolloProvider>
  </Provider>
);

const App = memo(() => {
  return (
    <AppWrapper>
      <AccountButton />
    </AppWrapper>
  );
});

if (typeof window !== 'undefined') {
  window.simulateExpiredToken = createSimulateExpiredToken(store);
}

App.displayName = 'App';

export default App;
